export default __webpack_public_path__ + "static/media/loremfund.840f79f5.png";